import React from 'react';
import HowToPlaySlider from './HowToPlaySlider';
import FeatureSlider from './FeatureSlider';
import "../landing.scss";
import TestimonialSlider from './TestimonialSlider';
import ClientSlider from './ClientSlider';
import { ToastOverError } from "../../../common/Toast/ToastOver";
import { server } from "../../../common/Apis/axiosBaseURL";
function Home() {

    const handleDownloadAPK = (type) => {
        if (type == "android") {
            // const apkUrl = (type == "android" ? `${server.baseURL}/apk/millionaire11.apk` : "");
            const apkUrl = (type == "android" ? `/apk/millionaire11.apk` : "");
            const link = document.createElement('a');
            link.href = apkUrl;
            link.download = "millionaire11.apk";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            ToastOverError("APK is currently under development, so please try again later.")
        }
    };

    return (
        <>
            <section className="banner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="banner_part">
                                <div className="banner_details">
                                    <h1 className="banner_title" id="textHero">WELCOME TO <br />
                                        <span className="rocky_text" id="textHero_2">
                                            <span className="fantasy">Millionaire11</span>
                                        </span>
                                    </h1>
                                    <div className="getAppGroup">
                                        <a href="https://apps.apple.com/in/app/millionaire11/id6744609804" target="_blank">
                                            <img src="/images/website/appStore.png" alt="" />
                                        </a>
                                        <button type="button" onClick={() => handleDownloadAPK("android")} className="themeBtn2_2 download-now-btn">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="23.225" height="26.68" viewBox="0 0 23.225 26.68">
                                                <path d="M13.413,26.223a1.557,1.557,0,0,1-.457-1.1V21.356H10.269v3.765a1.559,1.559,0,0,1-3.119,0V21.356H6.021a1.777,1.777,0,0,1-1.775-1.775V8.964H18.978V19.581A1.776,1.776,0,0,1,17.2,21.356H16.075v3.765a1.559,1.559,0,0,1-2.662,1.1Zm7.15-7.531a1.561,1.561,0,0,1-.457-1.1V10.523a1.559,1.559,0,0,1,3.119,0v7.066a1.559,1.559,0,0,1-2.662,1.1Zm-20.106,0A1.561,1.561,0,0,1,0,17.589V10.523a1.559,1.559,0,0,1,3.119,0v7.066a1.559,1.559,0,0,1-2.662,1.1ZM4.246,8.085a5.193,5.193,0,0,1,.216-1.327A6.751,6.751,0,0,1,7.481,2.808l.249-.149L8,2.528l-.3-.515L6.819.354a.229.229,0,0,1-.03-.088A.275.275,0,0,1,6.8.173.241.241,0,0,1,6.839.091.231.231,0,0,1,6.91.03.254.254,0,0,1,7,0,.241.241,0,0,1,7.09.009a.238.238,0,0,1,.082.042.224.224,0,0,1,.06.07l.9,1.66.282.514.282-.116.266-.1a8.09,8.09,0,0,1,5.309,0l.281.1.266.116.282-.514.9-1.544a.276.276,0,0,1,.094-.082.289.289,0,0,1,.122-.034h.115A.231.231,0,0,1,16.41.24a.233.233,0,0,1,0,.146l-.879,1.659-.3.515.266.133.248.149a6.844,6.844,0,0,1,3.037,3.915,6.029,6.029,0,0,1,.2,1.327ZM14.8,4.564a.66.66,0,0,0-.339.181.667.667,0,0,0-.182.34.66.66,0,0,0,.282.681.663.663,0,0,0,1.032-.551.66.66,0,0,0-.409-.614.649.649,0,0,0-.384-.037Zm-6.635,0a.657.657,0,0,0-.521.521.651.651,0,0,0,.037.384.67.67,0,0,0,.245.3.661.661,0,0,0,.369.112.663.663,0,0,0,.663-.663.661.661,0,0,0-.112-.369.67.67,0,0,0-.3-.245A.659.659,0,0,0,8.3,4.551.639.639,0,0,0,8.165,4.564Z" fill='currentColor'/>
                                            </svg>
                                            Download Now  
                                        </button>
                                        {/* <button type='button'>
                                            <img src="/images/website/googlePlay.png" alt="" />
                                        </button> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="heroShape" id="hero_shape">
                    <img src="/images/website/hero_shape.png" alt='' />
                </div> */}
                <div className="heroArrow" id="hero_Arrow">
                    <img src="/images/website/arrowHero.png" alt="" />
                </div>
            </section>

            <section className="about_us" >
                <div id="about_usId" className="top_min"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="light_heading" id="aboutHeading">About Us</h2>
                        </div>
                    </div>
                    <div className="row align-items-center row_spece gx-2">
                        <div className="col-md-7 order-last order-md-first">
                            <div className="aboutHeading_content">
                                <div className="heading">
                                    About Millionaire11
                                </div>
                                <p>
                                    Welcome to Millionaire11, the premier destination for fantasy real-money games hosted by MILLIONAIRE11 FANTASY SPORTS PRIVATE LIMITED. Our mission is to provide a safe, engaging, and respectful environment for users to participate in contests, share ideas, and connect with like-minded individuals.
                                </p>
                                {/* <p>
                                    Technology Partner: We are proud to collaborate with Payjini Technologies Private Limited as our esteemed technology partner. Payjini Technologies provides us with cutting-edge technological support to ensure a seamless and enjoyable experience for our users.
                                </p> */}
                            </div>
                            <a href="community-guidelines" className="themeBtn2_2">
                                Learn More
                                <img src="/images/website/theme_2_arrow.svg" alt="aero" />
                            </a>
                        </div>
                        <div className="col-md-5 order-first order-md-last">
                            <div className="mobile_img">
                                <img src="/images/website/about-us.png" alt="mobile" />
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <HowToPlaySlider />

            <svg viewBox="0 0 100 100" className="d-none" xmlns="http://www.w3.org/2000/svg">
                <filter id="clientOver">
                    <feColorMatrix type="matrix"
                        values="0 0 0 0 0.6078
            0 0 0 0 0.6078
            0 0 0 0 0.6078
            0 0 0 1 0" />
                </filter>
            </svg>

            <ClientSlider />

            <FeatureSlider />

            <TestimonialSlider />


            <section className="getAppSection">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-sm-7 col-lg-6">
                            <div className="appGetcontnt">
                                <h2 className="commonHeading">Get the App Now</h2>
                                <p>Ready to start winning? Download the Millionaire11 app now and experience the thrill of fantasy sports like never before!</p>

                                <div className="getAppGroup">
                                    <a href="https://apps.apple.com/in/app/millionaire11/id6744609804" target="_blank">
                                        <img src="/images/website/appStore.png" alt="" />
                                    </a>
                                    {/* <button type='button'>
                                        <img src="/images/website/googlePlay.png" alt="" />
                                    </button> */}
                                    <button type='button' className='download-now-btn themeBtn2_2' onClick={() => handleDownloadAPK("android")}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="23.225" height="26.68" viewBox="0 0 23.225 26.68">
                                            <path d="M13.413,26.223a1.557,1.557,0,0,1-.457-1.1V21.356H10.269v3.765a1.559,1.559,0,0,1-3.119,0V21.356H6.021a1.777,1.777,0,0,1-1.775-1.775V8.964H18.978V19.581A1.776,1.776,0,0,1,17.2,21.356H16.075v3.765a1.559,1.559,0,0,1-2.662,1.1Zm7.15-7.531a1.561,1.561,0,0,1-.457-1.1V10.523a1.559,1.559,0,0,1,3.119,0v7.066a1.559,1.559,0,0,1-2.662,1.1Zm-20.106,0A1.561,1.561,0,0,1,0,17.589V10.523a1.559,1.559,0,0,1,3.119,0v7.066a1.559,1.559,0,0,1-2.662,1.1ZM4.246,8.085a5.193,5.193,0,0,1,.216-1.327A6.751,6.751,0,0,1,7.481,2.808l.249-.149L8,2.528l-.3-.515L6.819.354a.229.229,0,0,1-.03-.088A.275.275,0,0,1,6.8.173.241.241,0,0,1,6.839.091.231.231,0,0,1,6.91.03.254.254,0,0,1,7,0,.241.241,0,0,1,7.09.009a.238.238,0,0,1,.082.042.224.224,0,0,1,.06.07l.9,1.66.282.514.282-.116.266-.1a8.09,8.09,0,0,1,5.309,0l.281.1.266.116.282-.514.9-1.544a.276.276,0,0,1,.094-.082.289.289,0,0,1,.122-.034h.115A.231.231,0,0,1,16.41.24a.233.233,0,0,1,0,.146l-.879,1.659-.3.515.266.133.248.149a6.844,6.844,0,0,1,3.037,3.915,6.029,6.029,0,0,1,.2,1.327ZM14.8,4.564a.66.66,0,0,0-.339.181.667.667,0,0,0-.182.34.66.66,0,0,0,.282.681.663.663,0,0,0,1.032-.551.66.66,0,0,0-.409-.614.649.649,0,0,0-.384-.037Zm-6.635,0a.657.657,0,0,0-.521.521.651.651,0,0,0,.037.384.67.67,0,0,0,.245.3.661.661,0,0,0,.369.112.663.663,0,0,0,.663-.663.661.661,0,0,0-.112-.369.67.67,0,0,0-.3-.245A.659.659,0,0,0,8.3,4.551.639.639,0,0,0,8.165,4.564Z" fill='currentColor'/>
                                        </svg>
                                        Download Now
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-5 col-lg-6 align-self-end">
                            <div className="getAppImg">
                                <img src="/images/website/getAppImg.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Home;